<template>
  <div class="animated fadeIn h-100 m-4">
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardHeader>
            <slot name="header">
              <CIcon name="cil-layers"/> Assets
            </slot>
          </CCardHeader>
          <CCardBody>
            <CDataTable
              :hover="true"
              :striped="true"
              :items="devices"
              :fields="fields"
              table-filter
              pagination
            >
              <template #device="{item}"><td><CLink :to="'assets/'+item.device">{{item.device}}</CLink></td></template>
              <template #time="{item}"><td>{{formatDate(item.time)}}</td></template>
              <template #event="{item}"><td>{{item.event == null ? 'N/A' : item.event }}</td></template>
              <template #zones="{item}"><td><CBadge v-if="m.name !== null" v-for="(m, index) in item.zones" :color="m.id == '00000000-0000-0000-0000-000000000000' ? 'warning' : 'info'" class="mr-1">{{m.name}}</CBadge></td></template>
              <template #tags="{item}"><td><CBadge v-for="(m, index) in item.tags" :color="'info'" class="mr-1">{{m}}</CBadge></td></template>
              <template #actions="{item}"><td><CLink v-on:click="editAsset(item)">edit</CLink></td></template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CModal :title="'Edit Asset - ' + assetID " color="dark" size="lg" :centered="true" :closeOnBackdrop="false" :show.sync="editAssetModal">
      <CTabs>
        <CTab title="General">
          <CInput label="Asset Name" placeholder="Enter asset name" v-model="assetName" />
          <label for="tagsList">Tags: </label><vue-tags-input input-id="tagsList" v-model="tag" :tags="tags" :autocomplete-items="autotags" @tags-changed="newTags => tags = newTags" />
        </CTab>
        <CTab title="Configuration">
          
        </CTab>
        <CTab v-if="type=='iethings'" title="Configuration">
        </CTab>
      </CTabs>
      <template #footer>
        <CButton @click="saveAsset" color="success"  >Save</CButton>
        <CButton @click="editAssetModal=false" color="secondary" >Cancel</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import Vue from 'vue'
import { telemetry } from '@/api'
import CTableWrapper from './base/TableAssets.vue'
import VueTagsInput from '@johmun/vue-tags-input'

export default {
  name: 'Assets',
  components: {
      CTableWrapper,
      VueTagsInput
  },
  data () {
    return {
        devices: [],
        editAssetModal: false,
        assetName: '',
        assetID: '',
        type: '',
        tag: '',
        tags: [],
        fields: ['device', {key: 'devicename', label: 'Name'}, {key: 'time', label: 'Last event'}, 'event', 'tags', 'zones', 'actions']
    }
  },
  computed: {
    autotags() {
      var ret = []
      for(var idx=0; idx < this.$store.state.tags.length; idx++) ret.push({text: this.$store.state.tags[idx]})
      return ret
    },
    hasConfiguration() {
      return true
    }
  },
  mounted () {
    this.loadAssets()
  },
  methods: {
    loadAssets() {
      telemetry.devices().then(response => {
        if(response.data !== undefined) {
          this.devices = response.data
        }
      }).catch((error) => {
        this.$toasted.error('Unable to access server.')
      })
    },
    editAsset(item) {
      this.assetName = item.devicename
      this.assetID = item.device
      this.type = item.type
      this.tags = []
      if(item.tags != null) for(var idx=0; idx < item.tags.length; idx++) this.tags.push({text: item.tags[idx]})
      this.editAssetModal = true
    },
    saveAsset(){
      var tags = []
      for(var idx=0; idx < this.tags.length; idx++) tags.push(this.tags[idx].text)
      telemetry.updateDevice({id: this.assetID, name: this.assetName, tags: tags})
        .then(response => {
        this.$toasted.success('Device saved.')
        this.editAssetModal = false
        this.loadAssets()
      }).catch((error) => {
        this.$toasted.error('Unable to save device.')
      })
    },
    formatDate(date) {
      return date == null ? 'N/A' : (new Date(date*1000)).toLocaleString()
    }
  }
}
</script>
